import React from 'react';
import PropTypes from 'prop-types';
import Date from "components/Display/ViewDate";
import YesNo from "components/Display/YesNo";
import Amount from "components/Display/Amount";
import Percentage from "components/Display/Percentage";
import LegType from "../Display/LegType";

const BondSettingTable = ({ data }) => {

  if ((!data.bond) || (!data.isBond)){
    return (
      <div/>
    );
  }
  let bond = data.bond;
  let leg = data.bond.legs[0];
  let calledInContent;

  if (leg.calledInBecauseOfDefault){
    calledInContent = (
      <span> vegna vanskil. </span>
    );
  }

  return (
    <div className="calc-setting-table ">
      <table className="table">
          <colgroup>
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="2" className="text-left calc-setting-table-header">Skuldabréf</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th className="text-right">Tegund</th>
            <td className="text-right"><LegType data={leg.legType}/></td>
          </tr>
          <tr>
            <th className="text-right">Nafnverð</th>
            <td className="text-right"><Amount data={leg.amount}/></td>
          </tr>
          <tr>
            <th className="text-right">Skuldbreyting</th>
            <td className="text-right"><Amount data={leg.debtRestructureAmount}/></td>
          </tr>
          <tr>
            <th className="text-right">Fjöldi afborgana</th>
            <td className="text-right">{leg.numberOfPayments}</td>
          </tr>
          <tr>
            <th className="text-right">Fjöldi vaxtaborgana</th>
            <td className="text-right">{leg.numberOfInterestPayments}</td>
          </tr>
          <tr>
            <th className="text-right">Mánuðir milli gjalddaga</th>
            <td className="text-right">{leg.monthsBetweenPayments}</td>
          </tr>

          <tr>
            <th className="text-right">Útgáfudagur</th>
            <td className="text-right"><Date data={leg.issueDate}/></td>
          </tr>
          <tr>
            <th className="text-right">Fyrsti gjalddagi</th>
            <td className="text-right"><Date data={leg.firstPaymentDate}/></td>
          </tr>
          <tr>
            <th className="text-right">Fyrstu vanskil</th>
            <td className="text-right"><Date data={bond.firstNeglectPaymentDate}/></td>
          </tr>

          <tr>
            <th className="text-right">Samningsvaxtadagur</th>
            <td className="text-right"><Date data={leg.contractInterestDate}/></td>
          </tr>
          <tr>
            <th className="text-right">Fastir samningsvextir</th>
            <td className="text-right"><Percentage data={leg.contractInterests[0].fixedContractInterest}/></td>
          </tr>
          <tr>
            <th className="text-right">Skerða samningsvexti</th>
            <td className="text-right"><YesNo data={leg.contractInterests[0].contractInterestCutt}/></td>
          </tr>
          <tr>
            <th className="text-right">Vaxtaálag</th>
            <td className="text-right"><Percentage data={leg.contractInterests[0].interestMargin}/></td>
          </tr>
          <tr>
            <th className="text-right">Verðtrygginardagur</th>
            <td className="text-right"><Date data={leg.indexInterestDate}/></td>
          </tr>
          <tr>
            <th className="text-right">Gjaldfellt</th>
            <td className="text-right"><YesNo data={leg.calledIn}/>
              {calledInContent}</td>
          </tr>
          <tr>
            <th className="text-right">Gjaldfellingardagur</th>
            <td className="text-right"><Date data={leg.calledInDate}/></td>
          </tr>
          <tr>
            <th className="text-right">Neikvæð vísitala.</th>
            <td className="text-right"><YesNo data={leg.negativeIndex}/></td>
          </tr>
          <tr>
            <th className="text-right">Uppgreiðslugjald</th>
            <td className="text-right"><Amount data={leg.amount}/></td>
          </tr>
          <tr>
            <th className="text-right">Í greiðslujöfnun</th>
            <td className="text-right"><YesNo data={leg.isEqualization}/></td>
          </tr>
          <tr>
            <th className="text-right">Fyrsti jöfnunargjaldagi</th>
            <td className="text-right"><Date data={leg.equalizationStartDate}/></td>
          </tr>
          <tr>
            <th className="text-right">Grunngreiðslumark</th>
            <td className="text-right"><Amount data={leg.equalizationLimit}/></td>
          </tr>
          <tr>
            <th className="text-right">Eftirst. á jöfnunarreikn við vanskil</th>
            <td className="text-right"><Amount data={leg.equalizationRemainder}/></td>
          </tr>
          </tbody>
        </table>

      </div>
  );
};

BondSettingTable.propTypes = {
  data: PropTypes.object,
};

export default BondSettingTable;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Settings/BondSettingTable.js